import DefaultHomecard from './DefaultHomecard';

export default DefaultHomecard;
